<div
    id="dashboard-project"
    class="page-layout simple right-sidebar"
    fxLayout="row"
>
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>
        <!-- HEADER -->
        <div
            class="header accent pl-48 pr-48 pb-24 pt-24"
            fxLayout="column"
            fxLayoutAlign="center start"
        >
            <div fxLayout="row" fxLayoutAlign="start center">
                <span
                    class="mat-display-1 welcome-message"
                    [@animate]="{ value: '*', params: { x: '50px' } }"
                    >Bem Vindo(a), {{ user.name }}
                </span>
            </div>
        </div>
        <!-- / HEADER -->

        <!-- CONTENT -->
        <div class="content">
            <div
                class="widget-group"
                fxLayout="column"
                fxLayout.gt-md="row"
                fxFlex="100"
                *fuseIfOnDom
                [@animateStagger]="{ value: '50' }"
            >
                <div fxLayout="column" fxFlex="100" fxFlex.gt-md="40">

                    <!-- TO-DO LIST -->
                    <fuse-widget
                        [@animate]="{ value: '*', params: { y: '100%' } }"
                        fusePerfectScrollbar
                    >
                        <lista-atividades class="fuse-widget-front">
                        </lista-atividades>
                    </fuse-widget>
                    <!-- / TO-DO LIST -->

                    <!-- SALDO DISPONIVEL -->
                    <fuse-widget
                        [@animate]="{ value: '*', params: { y: '100%' } }"
                        fusePerfectScrollbar
                    >
                        <saldo-disponivel-component class="fuse-widget-front">
                        </saldo-disponivel-component>
                    </fuse-widget>
                    <!-- / AGENDA DO DIA -->
                </div>

                <!-- BOLETAS DE INTERMEDIACAO -->
                <fuse-widget
                    [@animate]="{ value: '*', params: { y: '100%' } }"
                    class="boletas-widget"
                    fxFlex="60"
                    style="height: 100%"
                    *ngIf="hasPermissionBoletas"
                >
                    <boletas-widget class="fuse-widget-front"> </boletas-widget>
                </fuse-widget>
                <!-- / BOLETAS DE INTERMEDIACAO -->
            </div>
        </div>
        <!-- / CONTENT -->
    </div>
    <!-- / CENTER -->
</div>
